
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ThemeData, QuestionData, ProductInput } from '../types';
import { Weekday, Weekend } from '@/enums';
import Question from '@/components/Question.vue';
import RegisterButton from '@/components/RegisterButton.vue';
import { t } from '@/utils';
import { mapGetters } from 'vuex';

@Component({
	components: {
		Question,
		RegisterButton
	},
	computed: mapGetters({
		inputs: 'getInputs',
		noProductQuestions: 'getNoProductQuestions',
	})
})

export default class Theme extends Vue {
	public canFinish:boolean = false;

	inputs!: ProductInput[];
	noProductQuestions!: number[];

	@Prop() data!: ThemeData;

	@Watch('inputs', { immediate: true, deep: true })
	onInputChange(newVal: any) {
		this.recalculateCanFinish();
	}

	@Watch('noProductQuestions', { immediate: true, deep: true })
	onNoProductQuestionsChange(newVal: any) {
		this.recalculateCanFinish();
	}

	mounted(): void {
		this.recalculateCanFinish();
	}

	private get chapterLabel(): string {
		return this.$store.state.currentChapter.label;
	}

	private get questions(): QuestionData[] {
		return Object.values(this.data.questions);
	}

	private recalculateCanFinish() : void {
		for (const question of this.questions) {
			const inputs: ProductInput[] = this.inputs.filter((i: ProductInput) => i.questionId == question.id);
			for (const input of inputs) {
				if (!this.inputHasAnyPortion(input)) {
					console.log(input);
					console.log('input has no portion 1');
					this.canFinish = false;

					return;
				}
			}

			if (inputs.length == 0 && !this.noProductQuestions.includes(question.id)) {
				console.log('input has no portion 2');
				this.canFinish = false;

				return;
			}
		}

		this.canFinish = true;

		return;
	}

	private inputHasAnyPortion(input: ProductInput): boolean {
		let days: string[];

		days = Object.values(Weekday);

		for (const day of days) {
			//console.log('day', day, input.selectedPortions[day].index);

			//@ts-ignore
			if (input.selectedPortions[day].index >= 0) {
				//console.log('day', day, input.selectedPortions[day].index);
				return true;
			}
		}

		return false;
	}

	private finish(): void {
		if (!this.canFinish) {
			return;
		}

		this.$emit('finish');
	}
}
